/**
 * Modelo de Orden de Compra
 */
export interface ItemOrdenCompra {
  numeroItem?: number;
  descripcion?: string;
  cantidad?: number;
  precioUnitario?: number;
}

export interface ProveedorOC {
  id?: string;
  nombreProveedor?: string;
  numRUC?: string;
}

export enum EstadoOC {
  Creado = 'CREADO',
  Rechazado = 'RECHAZADO',
  Pendiente = 'PENDIENTE',
  Parcial = 'PARCIAL',
  Pagada = 'PAGADA',
  Cancelada = 'CANCELADA',
}

export enum TipoEgreso {
  Financiamiento = 'FINANCIAMIENTO',
  Inversion = 'INVERSION',
  Operativos = 'OPERATIVOS',
}

export enum TipoOC {
  Administrativo = 'Administrativo',
  Financiero = 'Financiero',
  Operativo = 'Operativo',
  Compra = 'Compra',
  Servicio = 'Servicio',
}

export interface OrdenCompra {
  id?: string;
  createdAt?: string;
  tipoOC?: TipoOC | string;
  numeroOC?: string;
  fechaPago?: string | null;
  tipoEgreso?: TipoEgreso | string;
  categoriaEgreso?: string;
  proveedor?: ProveedorOC;
  moneda?: string;
  montoPagar?: number;
  observaciones?: string;
  estado?: EstadoOC | string;
  items?: ItemOrdenCompra[];
  tipoOrden?: 'Orden de Compra';
  updatedAt?: string;
}

export interface OrdenCompraInput {
  tipoOC?: string;
  numeroOC?: string;
  fechaPago?: string;
  tipoEgreso?: string;
  categoriaEgreso?: string;
  proveedorId?: string;
  moneda?: string;
  montoPagar?: number;
  observaciones?: string;
}
